import React from 'react';
import {Responsive, WidthProvider} from "react-grid-layout";
import {observer} from "mobx-react";
import ObjetElementaire from "../../ObjetsElementaires/ObjetElementaire";
import {useStores} from "../../../stores/Context";
import "../../../styles/NiveauxIndicateur.scss";
import {useParams} from "react-router-dom";
import axios from "axios";
import BtnSvg from "../../../boiteAOutils/BtnSvg";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const VoirIndicateurNiveaux = observer(({level, editing}) => {
    const {niveauxIndicateurStore, uiStore, widgetStore} = useStores();
    const {ent} = useParams();


    const handleDragStart = () => {
        uiStore.setDragging(true);
    }
    const handleDragEnd = () => {
        uiStore.setDragging(false);
    }
    const stopPropagation = (event) => {
        event.stopPropagation();
    };

    const onLayoutChange = (layout) => {
        if (layout.length > 0) {
            axios.post(process.env.REACT_APP_API_URL + '/api/indicateur/niveau/postUpdateObjElemPosition', {
                niveauLayout: layout
            }, { headers: {"Authorization" : `Bearer ${widgetStore._token}`} }).then(() => {
                niveauxIndicateurStore.updateLayoutLevel(layout)
            })
        }
    }

    const updateObjetElem = (id, type) => {
        niveauxIndicateurStore.handleUpdateObjetElem(id, type, ent);
        uiStore.setDragging(false);
    }

    const lgLayout = niveauxIndicateurStore.generateLayout(level.id);

    return (
        <div className={`${editing ? 'editing' : ''} niveau_indicateur  Niv_` + level.id} style={{position: 'relative'}}>
            {/*Niveau {level.id}*/}
            <ResponsiveReactGridLayout
                layouts={{lg: lgLayout}}
                onLayoutChange={onLayoutChange}
                className="layout_niveau_indicateur z-50"
                breakpoints={{
                    lg: 1080,
                    md: 996,
                    sm: 768,
                    xs: 480,
                    xxs: 0,
                }}
                cols={{
                    lg: 12,
                    md: 12,
                    sm: 12,
                    xs: 12,
                    xxs: 12,
                }}
                margin={[0, 0]}
                containerPadding={[0, 0]}
                rowHeight={100}
                width={9}
                autoSize={false}
                transformScale={1}

                // WidthProvider option
                measureBeforeMount={false}
                // I like to have it animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
                // and set `measureBeforeMount={true}`
                compactType={null}
                preventCollision={true}
                isDroppable={editing}
                isDraggable={editing}
                isResizable={editing}

                onDragStart={handleDragStart}
                onDragEnd={handleDragEnd}
            >
                {
                    lgLayout.map((el) => {
                        return (
                            <div
                                key={el.i}
                                data-grid={el}
                                onTouchStart={handleDragStart}
                                onTouchEndCapture={handleDragEnd}
                            >
                                { editing && (
                                    <>
                                        <BtnSvg svg={"parametre"} height={50} width={50}
                                                // className={"btnUpdateObjetElementaire"}
                                                // onMouseDown={stopPropagation}
                                                // onTouchStart={stopPropagation}
                                                onClick={(e) => {
                                                    console.table("BtnSvg Cog", [e, el]); // Affichez l'événement et el
                                                    e.stopPropagation(); // Utilisez e.stopPropagation() pour arrêter la propagation de l'événement
                                                    updateObjetElem(el.idWidget, el.typeWidget); // Accédez à el ici
                                                }}
                                                // onTouchEnd={(el) => updateObjetElem(el.idWidget, el.typeWidget)}
                                                style={{
                                                    position: "absolute",
                                                    top: "0.5em",
                                                    right: "0.7em",
                                                    zIndex: 999999
                                                }}
                                        />
                                        {/*<button*/}
                                        {/*    className="btnUpdateObjetElementaire"*/}
                                        {/*    onMouseDown={stopPropagation}*/}
                                        {/*    onTouchStart={stopPropagation}*/}
                                        {/*    onClick={() => {*/}
                                        {/*        updateObjetElem(el.idWidget, el.typeWidget)*/}
                                        {/*    }}*/}
                                        {/*    onTouchEnd={() => {*/}
                                        {/*        updateObjetElem(el.idWidget, el.typeWidget)*/}
                                        {/*    }}*/}
                                        {/*>*/}
                                        {/*    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19"*/}
                                        {/*         viewBox="0 0 18 19" fill="none">*/}
                                        {/*        <ellipse cx="8.99935" cy="9.75065" rx="2.83333" ry="2.91667"*/}
                                        {/*                 stroke="#A8B0B3" strokeWidth="2"/>*/}
                                        {/*        <path*/}
                                        {/*            d="M7.68967 2.35482C8.29545 1.3912 9.70325 1.3912 10.309 2.35482V2.35482C10.7039 2.98292 11.4915 3.24137 12.181 2.96759V2.96759C13.2238 2.55357 14.3449 3.35841 14.2861 4.47882L14.2811 4.57442C14.242 5.31939 14.727 5.99101 15.4465 6.18819V6.18819C16.5425 6.48858 16.9769 7.80992 16.2728 8.70202L16.2389 8.74498C15.7735 9.33466 15.7735 10.1666 16.2389 10.7563L16.2728 10.7993C16.9769 11.6914 16.5425 13.0127 15.4465 13.3131V13.3131C14.727 13.5103 14.242 14.1819 14.2811 14.9269L14.2861 15.0225C14.3449 16.1429 13.2238 16.9477 12.181 16.5337V16.5337C11.4915 16.2599 10.7039 16.5184 10.309 17.1465V17.1465C9.70325 18.1101 8.29545 18.1101 7.68967 17.1465V17.1465C7.29482 16.5184 6.50722 16.2599 5.81769 16.5337V16.5337C4.77493 16.9477 3.65381 16.1429 3.71259 15.0225L3.71761 14.9269C3.7567 14.1819 3.27168 13.5103 2.55222 13.3131V13.3131C1.45617 13.0127 1.02184 11.6914 1.72591 10.7993L1.75981 10.7563C2.22521 10.1666 2.22521 9.33466 1.75981 8.74498L1.72591 8.70202C1.02184 7.80991 1.45617 6.48858 2.55222 6.18819V6.18819C3.27168 5.99101 3.7567 5.31939 3.71761 4.57443L3.71259 4.47882C3.65381 3.35841 4.77493 2.55357 5.81769 2.96759V2.96759C6.50722 3.24137 7.29482 2.98292 7.68967 2.35482V2.35482Z"*/}
                                        {/*            stroke="#A8B0B3" strokeWidth="2"/>*/}
                                        {/*    </svg>*/}
                                        {/*</button>*/}

                                        <BtnSvg svg={"corbeille"} height={50} width={50}
                                                onClick={(e) => {
                                                    stopPropagation(e)
                                                    niveauxIndicateurStore.removeObjetElem(el.idWidget, ent)
                                                }}
                                                style={{
                                                    position: "absolute",
                                                    top: "0.5em",
                                                    left: "0.7em",
                                                    zIndex: 999999
                                                }}
                                        />


                                        {/*<button*/}
                                        {/*    className="btnRemoveObjetElementaire" onMouseDown={stopPropagation}*/}
                                        {/*    onTouchStart={stopPropagation}*/}
                                        {/*    onTouchEnd={(e) => {*/}
                                        {/*        niveauxIndicateurStore.removeObjetElem(el.idWidget, ent)*/}
                                        {/*    }}*/}
                                        {/*    onClick={(e) => {*/}
                                        {/*        niveauxIndicateurStore.removeObjetElem(el.idWidget, ent)*/}
                                        {/*    }}>*/}
                                        {/*    <span*/}
                                        {/*        aria-hidden="true">*/}
                                        {/*        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"*/}
                                        {/*             viewBox="0 0 16 16" fill="none">*/}
                                        {/*      <path*/}
                                        {/*          d="M2.80939 12.1492L2.38523 3.66602H13.6161L13.1919 12.1492C13.1121 13.7458 11.7943 14.9993 10.1957 14.9993H5.80565C4.20703 14.9993 2.88922 13.7458 2.80939 12.1492Z"*/}
                                        {/*          stroke="#F82121" strokeWidth="2"/>*/}
                                        {/*      <path d="M5.66602 3H10.3327C10.3327 1.89543 9.43725 1 8.33268 1H7.66601C6.56145 1 5.66602 1.89543 5.66602 3Z"*/}
                                        {/*            stroke="#F82121" strokeWidth="2"/>*/}
                                        {/*      <path d="M0.666016 3.33398H15.3327" stroke="#F82121" strokeWidth="2"/>*/}
                                        {/*      <path d="M10 7.33398V10.6673" stroke="#F82121" strokeWidth="2"/>*/}
                                        {/*      <path d="M6 7.33398V10.6673" stroke="#F82121" strokeWidth="2"/>*/}
                                        {/*    </svg>*/}
                                        {/*    </span>*/}
                                        {/*</button>*/}
                                    </>
                                )}


                                <ObjetElementaire idObjet={el.idWidget} typeObjet={el.typeWidget}/>

                            </div>
                        )
                    })
                }
            </ResponsiveReactGridLayout>
        </div>
    );
});

export default VoirIndicateurNiveaux;
